module.exports = __webpack_public_path__ + "img/Qatar-airways.c4190bb4.jpg";